import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Link } from 'react-router-dom'

function FormLogin() {

  const navigate = useNavigate()

  return (
    <>
      <form onSubmit={() => navigate('/home')} className='form'>
        <h1 className="title form">Login</h1>
        <input type='email' placeholder='Email' />
        <input type='password' placeholder='Password' />
        <input type="submit" value='Sign In' />
        <Link to='/forgot' className="title form mini">Forgot Password?</Link>
        <Link to='/signup' className="title form medium">Create Account</Link>
      </form>
    </>
  )
}

export {FormLogin}
